<mat-card *ngFor="let casino of casinoList" class="casino-card" (click)="openGame(casino)">
  <mat-card-header>
    <mat-card-title>{{ casino.Title }}</mat-card-title>
    <mat-card-subtitle>{{ item.text }}</mat-card-subtitle>
  </mat-card-header>
  <img mat-card-image src="{{ casino.Img.indexOf('http') > -1 ? casino.Img : '/images/b500/casino/' + casino.Img }}" />
  <mat-card-actions>
    <button mat-button>{{ 'play' | t }}</button>
  </mat-card-actions>
</mat-card>
